import React from 'react';
import CheckoutCart from '../checkout/cart';
import ViewController from './view_controller';

const MobilePersonalUpgradeWrapper = (props) => (
  <CheckoutCart
    checkoutCart={props.checkoutCart}
    discounts={props.discounts}
    products={props.products}
    stripeUrls={props.stripeUrls}
    extraListings={props.extraListings}
    message={props.message}
    experiments={props.experiments}
    upgradeContext={props.staticData.miscellaneous.context}
    currencySymbol={props.staticData.site.currency_symbol}
    extraListingSwitch={props.extraListingSwitch}
    userType={props.userType}
    localisations={props.localisations.upgrade}
    siteId={props.staticData.site.id}
    walletButtons={props.walletButtons}
    numAds={
      props.pageData && props.pageData.num_ads ? props.pageData.num_ads : null
    }
    userUpgraded={props.staticData.customer.bold}
    render={({
      checkoutTotal,
      checkoutSubTotal,
      currentProduct,
      updateCart,
      storeOrderDetails,
      stripeUrls,
      addExtraListings,
      extraListingsTotal,
      extraListingsCount,
      extraListingsSelectedId,
      availableExtraListings,
      addDefaultExtraListings,
    }) => {
      const { extraListings, extraListingSwitch, userType } = props;

      const extraListingsAvailable =
        extraListings && extraListingSwitch && userType == 'offerer';

      return (
        <section>
          <ViewController
            {...props}
            checkoutTotal={checkoutTotal}
            checkoutSubTotal={checkoutSubTotal}
            currentProduct={currentProduct}
            storeOrderDetails={storeOrderDetails}
            updateCart={updateCart}
            stripeUrls={stripeUrls}
            beforeSubmitErrorCheck={props.beforeSubmitErrorCheck}
            addExtraListings={addExtraListings}
            extraListingsTotal={extraListingsTotal}
            extraListingsCount={extraListingsCount}
            extraListingsSelectedId={extraListingsSelectedId}
            availableExtraListings={availableExtraListings}
            experiments={props.experiments}
            extraListingsAvailable={extraListingsAvailable}
            extraListingSwitch={extraListingSwitch}
            extraListings={{
              total: extraListingsTotal,
              count: extraListingsCount,
              id: extraListingsSelectedId,
            }}
            gaLabel={props.staticData.site.loginReturnPath}
            gaAction={props.pageData ? props.pageData.name : ''}
            localisations={props.localisations.upgrade}
            userType={props.userType}
            addDefaultExtraListings={addDefaultExtraListings}
            walletButtons={props.walletButtons}
          />
        </section>
      );
    }}
  />
);

export default MobilePersonalUpgradeWrapper;
